import { TransactionType } from '@shared/transactions-types';

import { useTransactionsMetadata } from './useTransactionsMetadata';

export function useHasBulkTransactions(): boolean {
    const { data } = useTransactionsMetadata({
        searchState: { type: TransactionType.BULK },
    });

    return Boolean(data?.totalElements);
}
